import type { EventRecord } from '@vlabs/api/artemy/model';
import type { Event } from '@vlabs/api/luna-api/model';

import {
  BackpackAttributeCard,
  HeadwearAttributeCard,
  LowerBodyAttributeCard,
  UpperBodyAttributeCard,
} from '@vlabs/monokit/shared/ui/atribute-cards';

import st from './AttributesCell.module.sass';

interface BodyAttributesRowProps {
  accessories?: Event['accessories'] | EventRecord['accessories'];
  lowerBody?: Event['lower_body'] | EventRecord['lower_body'];
  upperBody?: Event['upper_body'] | EventRecord['upper_body'];
}

function hasAttributeValue<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined;
}

function BodyAttributesRow({
  accessories = undefined,
  lowerBody = undefined,
  upperBody = undefined,
}: BodyAttributesRowProps): React.JSX.Element | null {
  const backpack = accessories?.backpack?.state;
  const headwear = upperBody?.headwear;

  const hasBodyRow = hasAttributeValue(upperBody)
    || hasAttributeValue(lowerBody)
    || hasAttributeValue(backpack)
    || hasAttributeValue(headwear);

  if (!hasBodyRow) return null;

  return (
    <div className={st.BodyRow}>
      {hasAttributeValue(upperBody) && (
        <UpperBodyAttributeCard
          className={st.AttributeCard}
          values={upperBody}
        />
      )}

      {hasAttributeValue(lowerBody) && (
        <LowerBodyAttributeCard
          className={st.AttributeCard}
          values={lowerBody}
        />
      )}

      {hasAttributeValue(backpack) && (
        <BackpackAttributeCard
          backpack={backpack}
          className={st.AttributeCard}
        />
      )}

      {hasAttributeValue(headwear) && (
        <HeadwearAttributeCard
          className={st.AttributeCard}
          color={headwear.apparent_color}
          headwear={headwear.state}
        />
      )}
    </div>
  );
}

export { BodyAttributesRow };
